export interface CsEditState {
  canUndo: boolean;
  canRedo: boolean;
  canSave: boolean;
  isSaving: boolean;
  cs: CustomSearchDefinition;
  db?: Database;
  mode?: string;
  undo(): void;
  redo(): void;
  save(): void;
  snapshot(): void;
}

export interface CustomSearchFieldEx extends CustomSearchField {
  enabled: boolean;
  system: string[];
}
export const COMMON_SEARCH_FIELD: CustomSearchFieldEx[] = [
  {
    key: 'title',
    name: {
      ja: 'タイトル',
      en: 'Title',
    },
    fields: ['common.title', 'common.titleEn', 'common.titleYomi'],
    type: 'keyword',
    enabled: false,
    description: {
      ja: '共通項目のタイトル（日・英・読み）で検索します',
      en: 'Search with  title common fields',
    },
    system: ['jps', 'hina'],
  },
  {
    key: 'cm',
    name: {
      ja: '分野',
      en: 'Field',
    },
    fields: ['common.category'],
    type: 'code',
    codeKey: 'jps-db_category',
    hasFacet: true,
    enabled: false,
    description: {
      ja: 'データベースの分野で絞り込みます',
      en: 'Narrow down results with area of database',
    },
    system: ['jps'],
  },
  {
    key: 'cm',
    name: {
      ja: 'カテゴリー',
      en: 'Category',
    },
    fields: ['common.category'],
    type: 'code',
    codeKey: 'jps-db_category',
    hasFacet: true,
    enabled: false,
    description: {
      ja: 'データベースのカテゴリーで絞り込みます',
      en: 'Narrow down results with category of database',
    },
    system: ['hina'],
  },
  {
    key: 'type',
    name: {
      ja: '種類',
      en: 'Type',
    },
    type: 'rdf_type',
    enabled: false,
    description: {
      ja: 'RDF由来の資料の種別で絞り込みます',
      en: 'Narrow down results with type of data comes from RDF',
    },
    system: ['jps', 'hina'],
  },
  {
    key: 'rights',
    name: {
      ja: '利用条件',
      en: 'Use Condition',
    },
    fields: ['common.contentsRightsType'],
    type: 'code',
    codeKey: 'jps-facet_rights_type',
    enabled: false,
    hasFacet: true,
    description: {
      ja: 'コンテンツの利用条件で絞り込みます',
      en: 'Narrow down results with use conditions of contents',
    },
    system: ['jps', 'hina'],
  },
  {
    key: 'contents',
    name: {
      ja: 'コンテンツ',
      en: 'Contents',
    },
    type: 'contents',
    enabled: false,
    description: {
      ja: 'コンテンツの有無や種類で絞り込みます',
      en: 'Narrow down results with type of contents',
    },
    system: ['jps', 'hina'],
  },
  {
    key: 'db',
    name: {
      ja: 'データベース',
      en: 'Database',
    },
    type: 'database',
    enabled: false,
    description: {
      ja: 'データベースで絞り込みます',
      en: 'Narrow down results with databases',
    },
    system: ['jps', 'hina'],
  },
  {
    key: 'org',
    name: {
      ja: '連携機関',
      en: 'Organization',
    },
    type: 'organization',
    enabled: false,
    description: {
      ja: 'データベースの管理機関で絞り込みます',
      en: 'Narrow down results with organizations',
    },
    system: ['jps', 'hina'],
  },
  {
    key: 'provider',
    name: {
      ja: '所蔵機関',
      en: 'Holding agent',
    },
    type: 'provider',
    enabled: false,
    description: {
      ja: 'データの所蔵機関で絞り込みます',
      en: 'Narrow down results with holding agenets',
    },
    system: ['jps', 'hina'],
  },
  {
    key: 'tempo',
    name: {
      ja: '時間/時代',
      en: 'Time',
    },
    type: 'temporal',
    enabled: false,
    description: {
      ja: '年や時代で検索します',
      en: 'Search with year or era',
    },
    system: ['jps'],
  },
  {
    key: 'tempo',
    name: {
      ja: '時間',
      en: 'Time',
    },
    type: 'temporal',
    enabled: false,
    description: {
      ja: '年や時代で検索します',
      en: 'Search with year or era',
    },
    system: ['hina'],
  },
  {
    key: 'tempo_group',
    name: {
      ja: '時間',
      en: 'Time',
    },
    type: 'temporal_group',
    hasFacet: true,
    enabled: false,
    description: {
      ja: '年月日で検索します',
      en: 'Search with date',
    },
    system: ['hina'],
  },
  {
    key: 'loc',
    name: {
      ja: '場所',
      en: 'Location',
    },
    type: 'location',
    enabled: false,
    description: {
      ja: '場所のキーワードや地図から検索します',
      en: 'Search with location/map',
    },
    system: ['jps', 'hina'],
  },
  {
    key: 'prefectures',
    name: {
      ja: '場所/都道府県',
      en: 'Location',
    },
    type: 'prefectures',
    hasFacet: true,
    enabled: false,
    description: {
      ja: '都道府県や地図から検索します',
      en: 'Search with prefecture/map',
    },
    system: ['hina'],
  },
  {
    key: 'contributor',
    name: {
      ja: '人物/団体',
      en: 'Contributor',
    },
    fields: ['common.contributor'],
    type: 'keyword',
    enabled: false,
    description: {
      ja: '人物・団体のキーワードで検索します',
      en: 'Search with contributor',
    },
    system: ['jps', 'hina'],
  },
  {
    key: 'upd',
    name: {
      ja: '最終更新日',
      en: 'Last Updated',
    },
    type: 'last_update',
    enabled: false,
    description: {
      ja: '最終更新日で絞り込みます',
      en: 'Search with last updated date of metadata',
    },
    system: ['jps', 'hina'],
  },
  {
    key: 'image',
    name: {
      ja: '画像検索',
      en: 'Image Search',
    },
    type: 'image',
    enabled: false,
    description: {
      ja: 'サムネイルの画像検索を行います',
      en: 'Image search using thumbnails',
    },
    system: ['jps', 'hina'],
  },
  {
    key: 'subject',
    name: {
      ja: '主題',
      en: 'Subject',
    },
    fields: ['common.subject'],
    type: 'keyword',
    enabled: false,
    description: {
      ja: '主題のキーワードで検索します',
      en: 'Search with subject',
    },
    system: ['hina'],
  },
  {
    key: 'language',
    name: {
      ja: '言語',
      en: 'Language',
    },
    fields: ['common.language'],
    type: 'code',
    codeKey: 'jps-language',
    hasFacet: true,
    enabled: false,
    description: {
      ja: '言語で検索します',
      en: 'Search with language',
    },
    system: ['hina'],
  },
];

export interface CustomSearchColumnEx extends CustomSearchColumn {
  key: string;
  enabled: boolean;
  description: LangString;
  system: string[];
}

interface SearchFieldTypeBehavior {
  facet?: boolean;
  fields?: boolean;
  keyword?: boolean;
  code?: boolean;
  indexType?: string[];
}

// 'string'|'keyword'|'html'|'uri'|'bool'|'date'|'latlon'|'code'|'number'|'exists'|'none';
export const CUSTOM_SEARCH_FIELD_BEHAVIORS: {
  [id in SearchFieldType]: SearchFieldTypeBehavior;
} = {
  keyword: {
    facet: true,
    fields: true,
    keyword: true,
    indexType: ['string', 'keyword', 'html'],
  },
  code: { fields: true, code: true, indexType: ['code'] },
  coordinates: { fields: true, indexType: ['latlon'] },
  time_range: { fields: true, indexType: ['date'] },
  number_range: { fields: true, indexType: ['number'] },
  exist: {
    fields: true,
    indexType: [
      'string',
      'keyword',
      'html',
      'uri',
      'bool',
      'date',
      'latlon',
      'code',
      'number',
      'exists',
    ],
  },
  last_update: {},
  organization: {},
  provider: {},
  location: { keyword: true },
  prefectures: {},
  temporal: { keyword: true },
  temporal_group: {},
  database: {},
  contents: {},
  tag: {},
  rdf_type: {},
  image: {},
};

//表表示
export const COMMON_SEARCH_COLUMN: CustomSearchColumnEx[] = [
  {
    key: 'database',
    header: { ja: 'データベース', en: 'Database' },
    type: 'database',
    fields: null,
    description: { ja: '' },
    enabled: false,
    codeKey: null,
    system: ['jps', 'hina'],
  },
  {
    key: 'provider',
    header: { ja: '所蔵・所在', en: 'Contents holder/Provider' },
    type: 'provider',
    fields: null,
    description: { ja: '' },
    enabled: false,
    codeKey: null,
    system: ['jps', 'hina'],
  },
  {
    key: 'organization',
    header: { ja: 'つなぎ役機関', en: 'Organization' },
    type: 'organization',
    fields: null,
    description: { ja: '' },
    enabled: false,
    codeKey: null,
    system: ['jps', 'hina'],
  },
  {
    key: 'contributor',
    header: { ja: '人物/団体', en: 'Contributor' },
    type: 'field',
    fields: ['common.contributor'],
    description: { ja: '人物/団体' },
    enabled: false,
    codeKey: null,
    system: ['jps', 'hina'],
  },
  {
    key: 'temporal',
    header: { ja: '時間/時代', en: 'Time' },
    type: 'field',
    fields: ['common.temporal'],
    description: { ja: '時間/時代' },
    enabled: false,
    codeKey: null,
    system: ['jps'],
  },
  {
    key: 'temporal',
    header: { ja: '時間', en: 'Time' },
    type: 'field',
    fields: ['common.temporal'],
    description: { ja: '時代' },
    enabled: false,
    codeKey: null,
    system: ['hina'],
  },
  {
    key: 'location',
    header: { ja: '場所', en: 'Location' },
    type: 'field',
    fields: ['common.location'],
    description: { ja: '場所' },
    enabled: false,
    codeKey: null,
    system: ['jps', 'hina'],
  },
];

export const useCsEditor = () => {
  const { $getCommonSearchField, $getCommonSearchColumn } = useNuxtApp()

  const initCsForEdit = (c: CustomSearchDefinition) => {
    if (!c.name) c.name = { ja: null };
    if (!c.image) c.image = {};
    if (!c.columns) c.columns = [];
    if (!c.constraints) c.constraints = [];
    if (!c.databaseIds) c.databaseIds = [];
    if (!c.description) c.description = {};
    if (!c.keywordFields) c.keywordFields = [];
    if (!c.keywordPlaceholder) c.keywordPlaceholder = {};
    if (!c.sampleQuery) c.sampleQuery = [];
    if (!c.searchFields) c.searchFields = [];
    if (!c.help) c.help = { ja: null, en: null };
  }

  const toCSField = (f: CustomSearchFieldEx): CustomSearchField => {
    return cloneExcept(f, 'enabled', 'description');
  }

  const toCSColumn = (f: CustomSearchColumnEx): CustomSearchColumn => {
    return cloneExcept(f, 'key', 'enabled', 'description');
  }

  const systemCommonSearchField = (): CustomSearchFieldEx[] => {
    return $getCommonSearchField()
  }

  const systemCommonSearchColumn = (): CustomSearchColumnEx[] => {
    return $getCommonSearchColumn()
  }

  return {
    initCsForEdit,
    toCSField,
    toCSColumn,
    systemCommonSearchField,
    systemCommonSearchColumn,
  }
}

